/**
 * Search, sort and filter lists and tables
 * @requires https://listjs.com/
 */

export default (() =>
{
  window.cartzilla = window.cartzilla || {};

  window.cartzilla.filterList = function (parent)
  {
    parent = parent || document;

    const filterListContainers = document.querySelectorAll('[data-filter-list]')

    if (filterListContainers.length === 0)
      return;

    // Clear button functions
    const createClearButton = (container, searchField) =>
    {
      const clearButton = document.createElement('button')
      clearButton.type = "button";
      clearButton.setAttribute('aria-label', 'Vymazat hledaný text');
      clearButton.className =
        'btn btn-sm btn-outline-secondary w-auto border-0 p-1 position-absolute top-50 end-0 translate-middle-y me-2 opacity-0'
      clearButton.innerHTML = `
        <svg class="opacity-75" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.619 5.381a.875.875 0 0 1 0 1.238l-12 12A.875.875 0 0 1 5.38 17.38l12-12a.875.875 0 0 1 1.238 0Z"/><path d="M5.381 5.381a.875.875 0 0 1 1.238 0l12 12a.875.875 0 1 1-1.238 1.238l-12-12a.875.875 0 0 1 0-1.238Z"/>
        </svg>
      `
      container.appendChild(clearButton);

      updateClearButtonVisibility(searchField, clearButton);

      return clearButton;
    }

    const updateClearButtonVisibility = (searchField, clearButton) =>
    {
      clearButton.classList.toggle('opacity-0', searchField.value === '');
    }

    const clearSearchField = (searchField, clearButton) =>
    {
      searchField.value = '';

      updateClearButtonVisibility(searchField, clearButton);
    }

    // Init list filtering
    filterListContainers.forEach(filterListContainer =>
    {
      const options = JSON.parse(filterListContainer.dataset.filterList);
      const searchFields = filterListContainer.querySelectorAll('.' + options.searchClass);

      if (!searchFields || searchFields.length === 0)
        return;

      const clearButton = createClearButton(searchFields[0].parentNode, searchFields[0]);

      searchFields.forEach(searchField =>
      {
        searchField.addEventListener('input', () =>
        {
          updateClearButtonVisibility(searchField, clearButton);

          // search
          var items = document.querySelectorAll('.' + options.listClass + ' .' + options.valueNames[0]);

          if (!items)
            return;

          items.forEach(item =>
          {
            var parent = item.parentNode;

            if (!parent)
              return;

            if (parent.innerText.toLowerCase().indexOf(searchField.value.trim().toLowerCase()) > -1)
              parent.classList.remove("d-none");
            else
              parent.classList.add("d-none");
          });
        });
      })

      clearButton.addEventListener('click', () =>
      {
        searchFields.forEach(searchField =>
        {
          clearSearchField(searchField, clearButton)
        });

        // clear filter
        var items = document.querySelectorAll('.' + options.listClass + ' .' + options.valueNames[0]);

        if (!items)
          return;

        items.forEach(item =>
        {
          if (!item.parentNode)
            return;

          item.parentNode.classList.remove("d-none");
        });
      });
    });
  }

  cartzilla.filterList();
  /* eslint-enable no-unused-vars, no-undef */
})()
